import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../Redux/Store/index.ts";
import { allGet } from "../Redux/Actions.tsx";
import { urlutenti } from "../lib/api.ts";
import SideBar from "../Components/SideBar.tsx";
import { Col, Container, Row } from "react-bootstrap";
import "./Impostazioni.css";
import Tabelle from "../Components/Table.tsx";
import { CantieriColumns, UtentiColumns } from "../lib/ColonneTabelle.ts";
import Header from "../Components/Header.tsx";
import { Profile } from "../lib/interface.ts";
import ModalFormUtenti from "../Components/ModalFormUtenti.tsx";
import PersonalProfile from "../Components/PersonalProfile.tsx";
import { useNavigate } from "react-router-dom";
import SettaggiAvanzati from "../Components/SettaggiAvanzati.tsx";

const Impostazioni: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const { token } = useSelector((state: RootState) => state.login);
  const utentiRedux = useSelector((state: RootState) => state.utenti.utenti || []);
  const { profilo } = useSelector((state: RootState) => state.login);
  const [arrayUtenti, setArrayUtenti] = useState<Profile[]>([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedUtente, setSelectedUtente] = useState<Profile | null>(null);
  const [action, setAction] = useState<"crea" | "modifica">("crea");
  const { cantieri } = useSelector((state: RootState) => state.cantieri.cantieri);

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (profilo.tipoUtente !== "ACCOUNT") {
  //     navigate("/");
  //   }
  // }, [profilo, navigate]);

  useEffect(() => {
    dispatch(allGet(urlutenti, token));
  }, [dispatch, token]);

  useEffect(() => {
    setArrayUtenti(utentiRedux);
  }, [utentiRedux]);

  const handleAddUtente = (nuovoUtente: Profile) => {
    setArrayUtenti((prevUtenti) => [...prevUtenti, nuovoUtente]);
  };

  const updateUtenti = (updatedUtente: Profile) => {
    setArrayUtenti((prevUtenti) =>
      prevUtenti.map((utente) => (utente.id === updatedUtente.id ? updatedUtente : utente))
    );
  };

  const setArrayUtentiState = (utenti: Profile[]) => {
    setArrayUtenti(utenti);
  };

  const handleUtenteClick = (utente: Profile) => {
    setAction("modifica");
    setSelectedUtente(utente);
    setModalOpen(true);
  };

  const openModal = (utente: Profile) => {
    setAction("modifica");
    setSelectedUtente(utente);
    setModalOpen(true);
  };

  return (
    <Container fluid className="d-flex justify-content-between" style={{ margin: "0", padding: "0" }}>
      <Container fluid style={{ margin: "0", padding: "0", width: "5%" }}>
        <SideBar />
      </Container>
      <Container fluid className="colonna">
        <div className="d-flex justify-content-center">
          <Header
            title="Impostazioni"
            buttons={[
              {
                label: "Aggiungi un nuovo utente",
                onClick: () => {
                  setAction("crea");
                  setSelectedUtente(null);
                  setModalOpen(true);
                },
              },
            ]}
          />
        </div>
        <div className="d-flex justify-content-center">
          <Row className="g-3 w-90-95">
            <Col xs={12} className="px-0 padb-3">
              <div className="home-table-settings">
                <h5 style={{ paddingBlockStart: "1rem", paddingInline: "2rem" }}>Utenti:</h5>
                <Tabelle
                  data={utentiRedux.filter((utente) => utente.id !== profilo.id)}
                  columns={UtentiColumns}
                  type={""}
                  openModal={openModal}
                />
              </div>
            </Col>
            <Col lg={5} className="impostazioni-container d-flex justify-content-center pe-2">
              <div className="under-impostazioni ">
                <SettaggiAvanzati />
              </div>
            </Col>
            <Col lg={7} className="impostazioni-container d-flex justify-content-center ps-2">
              <div className="under-impostazioni ">
                {" "}
                <PersonalProfile />
              </div>
            </Col>
          </Row>
          <ModalFormUtenti
            arrayUtenti={arrayUtenti}
            onAddUtente={handleAddUtente}
            updateUtenti={updateUtenti}
            setArrayUtenti={setArrayUtentiState}
            action={action}
            isModalOpen={isModalOpen}
            setModalOpen={setModalOpen}
            selectedUtente={selectedUtente}
            setSelectedUtente={setSelectedUtente}
            onUtenteClick={handleUtenteClick}
          />
        </div>
      </Container>
    </Container>
  );
};

export default Impostazioni;
